module.exports = "/packs/check_24px-641c0845ca715e8abd9c09b677860c6f.svg";